import { useRef, useState } from "react";
import { ImagePlus, X } from "lucide-react";

export const PhotoDrop = ({ file, onChange, testId = "photo-dropzone" }) => {
  const ref = useRef(null);
  const [drag, setDrag] = useState(false);
  const preview = file ? URL.createObjectURL(file) : null;

  const pick = (f) => f && f.type.startsWith("image/") && onChange(f);

  return (
    <div
      data-testid={testId}
      onClick={() => ref.current?.click()}
      onDragOver={(e) => { e.preventDefault(); setDrag(true); }}
      onDragLeave={() => setDrag(false)}
      onDrop={(e) => { e.preventDefault(); setDrag(false); pick(e.dataTransfer.files[0]); }}
      className={`relative flex min-h-[200px] cursor-pointer items-center justify-center overflow-hidden rounded-xl border-2 border-dashed transition-colors duration-200 ${drag ? "border-cyan-400 bg-cyan-400/5" : "border-white/15 hover:border-cyan-400/60"}`}
    >
      <input ref={ref} type="file" accept="image/*" className="hidden" data-testid={`${testId}-input`} onChange={(e) => pick(e.target.files[0])} />
      {preview ? (
        <>
          <img src={preview} alt="Prévia" className="absolute inset-0 h-full w-full object-cover" />
          <button type="button" data-testid={`${testId}-clear`} onClick={(e) => { e.stopPropagation(); onChange(null); }} className="absolute right-2 top-2 rounded-full bg-black/70 p-1.5 hover:bg-red-500">
            <X className="h-4 w-4" />
          </button>
        </>
      ) : (
        <div className="text-center">
          <ImagePlus className="mx-auto h-10 w-10 text-cyan-400" />
          <p className="mt-2 font-semibold">Arraste ou clique para escolher</p>
          <p className="font-mono-tech text-[11px] text-slate-500">JPG, PNG ou WEBP · até 10MB</p>
        </div>
      )}
    </div>
  );
};
